export const PAGE_SIZE = 25

export const EVENT_GROUP_MAP: Record<string, string[]> = {
  cashier_mgmt: [
    'cashier_created',
    'cashier_updated',
  ],
  device_mgmt: [
    'device_created',
    'device_updated',
  ],
  settings: [
    'settings_updated',
  ],
  loyalty: [
    'loyalty_created',
    'loyalty_updated',
    'reward_item_created',
    'reward_item_updated',
    'stamp_adjustment',
    'reward_adjustment',
    'birthday_reward_updated',
  ],
  gdpr: [
    'member_anonymised',
  ],
  admin_auth: [
    'admin_signed_in',
    'admin_signed_out',
    'password_reset_requested',
    'password_changed',
    'admin_sign_in_failed',
  ],
}

const CHANGES_KEY_ORDER = ['before', 'after', 'stamps_delta', 'rewards_delta', 'rewards_unlocked', 'reward_item']

export function sortChangesEntries(entries: [string, unknown][]): [string, unknown][] {
  return entries.sort(([a], [b]) => {
    const ai = CHANGES_KEY_ORDER.indexOf(a)
    const bi = CHANGES_KEY_ORDER.indexOf(b)
    if (ai !== -1 && bi !== -1) return ai - bi
    if (ai !== -1) return -1
    if (bi !== -1) return 1
    return a.localeCompare(b)
  })
}

export interface AuditLogEntry {
  id: string
  eventType: string
  actorAdminId: string | null
  actorName: string | null
  actorEmail: string | null
  targetEntityType: string | null
  targetEntityId: string | null
  targetEntityName: string | null
  changes: Record<string, unknown> | null
  reason: string | null
  note: string | null
  ipAddress: string | null
  userAgent: string | null
  createdAt: string
}